import { isArray, isFunction } from '../core'

type AddEventArr<K extends keyof HTMLElementEventMap> = [
  /** 事件名 */
  eventName: K,
  /** 事件监听方法 */
  listener: (ev: HTMLElementEventMap[K]) => any,
  /** 配置对象 */
  options?: boolean | AddEventListenerOptions
][]

function addEvent<T extends HTMLElement, K extends keyof HTMLElementEventMap>(
  /** 要绑定的dom */
  dom: T,
  /** 事件 */
  events: AddEventArr<K>
): () => void;
function addEvent<T extends HTMLElement, K extends keyof HTMLElementEventMap>(
  /** 要绑定的dom */
  dom: T,
  /** 事件名 */
  eventName: K,
  /** 绑定的事件 */
  listener: (ev: HTMLElementEventMap[K]) => any,
  /** 配置参数 */
  options?: boolean | AddEventListenerOptions
): () => void
function addEvent<T extends HTMLElement, K extends keyof HTMLElementEventMap>(dom: T, params1: any, params2?: any, params3?: any): () => void {
  const events: AddEventArr<K> = isFunction(params2) ? [ [ params1, params2, params3 ] ] : params1
  const unBinds: (() => void)[] = []
  events.forEach((event) => {
    if (isArray(event)) {
      dom.addEventListener(...event)
      unBinds.push(() => dom.removeEventListener(...event))
    }
  })
  return () => unBinds.forEach(t => t())
}

export {
  addEvent
}